import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import templateImagesApi from '@/features/dashboard/templateImages/api/templateImagesApi.ts';
import { templateImagesApiQueryKeys } from '@/features/dashboard/templateImages/api/templateImagesApi.queryKeys.ts';
import { TemplateImageDto } from '@/features/dashboard/templateImages/types/TemplateImageDto.ts';

const useGetTemplateImages = (enabled = true) => {
  return useQuery(getTemplateImagesQueryOptions(enabled));
};

export const getTemplateImagesQueryOptions = (
  enabled = true,
): UseQueryOptions<TemplateImageDto[]> => ({
  queryKey: templateImagesApiQueryKeys.all(),
  queryFn: () => templateImagesApi.list(),
  enabled,
});

export default useGetTemplateImages;
